export default __webpack_public_path__ + "images/0x1a2fcb585b327fadec91f55d45829472b15f17a4.png";